import { atom } from 'recoil';
import { IRole } from 'shared/types';

export const roles = atom<IRole[]>({
  key: 'roles',
  default: [],
});

